export const nicepayClientId = 'R2_9ff90e16fc1345a09f5bede25ea77aac'; 
